import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import classes from "./TabsContentBank.module.css"
import { ContentBankTabsEnum } from "../../../models/ContentBankTabsEnum";
import { onKeyDown } from "../../../service";

const TabsContentBank = ({ handleChange, dataAPI, fromPopup }) => {

    const texts = useSelector((state) => state.translate.texts);
    const uiData = useSelector((state) => state.general.uiData);
    const [tabList, setTabList] = useState()


    useEffect(() => {
        if (!dataAPI.tabs)
            handleChange("tabs", ContentBankTabsEnum.myMaterials)
    }, [dataAPI.tabs])

    useEffect(() => {
        if (uiData)
            setTabList([
                { text: texts.myMaterials, type: ContentBankTabsEnum.myMaterials },
                { text: texts.materialsIShared, type: ContentBankTabsEnum.sharedMaterials, disable: uiData.hidecb },
                { text: texts.headquartersMaterials, type: ContentBankTabsEnum.headquartersRepository, disable: uiData.hidecb },
                { text: texts.nationalData, type: ContentBankTabsEnum.nationalRepository, disable: uiData.hidecb },
                { text: texts.teacherFavorites, type: ContentBankTabsEnum.favorites, disable: true },
                { text: texts.recentUses, type: ContentBankTabsEnum.recentUses, disable: true }
            ])
    }, [uiData])

    const changeTab = (t) => {
        if (!t.disable) {
            handleChange("tabs", t.type)
        }
    }

    return (
        <div>
            <h1 className={classes.TabsContentBankTitle}>{texts.learningMaterialsRepository}</h1>
            {dataAPI?.tabs && <div className={classes.LibraryTabsWarrper}>
                {tabList && tabList.map((t, i) =>
                    <h2 key={i} className={`${classes.Tab} ${dataAPI.tabs == t.type && classes.CurrentTab} ${t.disable ? classes.TabDisable : ''}`} onClick={() => changeTab(t)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeTab(t))}> {t.text}</h2>
                )}

            </div>}
        </div >
    )
}

export default TabsContentBank;